<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'OPERATIONS.OPERATIONS' | transloco">
    <sbnb-operations-subnav></sbnb-operations-subnav>
    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'statements-add-edit-owner'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <div
      class="flex"
      *ngIf="{
        loading: (loading$ | async) || false,
        saving: (saving$ | async) || false,
        deleting: (deleting$ | async) || false,
        owner: owner$ | async,
        mode: mode$ | async
      } as vm">
      <div class="w-full">
        <app-feature-flag-tabs class="w-full">
          <sbnb-page-header navTabs>
            <h2 class="mb-0">Tell us about your customer</h2>
          </sbnb-page-header>
          <h2 class="mb-0">Tell us about your customer</h2>
        </app-feature-flag-tabs>
        <p>An Owner is the individual or company that you manage properties for.</p>

        <ng-container *ngIf="!vm.loading; else loadingTemplate">
          <hospitable-statements-owner-form
            *ngIf="vm.owner"
            [owner]="vm.owner"
            [mode]="vm.mode"
            [properties]="(propertiesState$ | async)?.data || []"></hospitable-statements-owner-form>

          <div *ngIf="vm.owner" class="flex justify-between max-w-2xl">
            <sbnb-button
              *ngIf="vm.owner.id"
              class="block mt-8"
              label="Delete"
              type="secondary"
              [disabled]="vm.loading"
              [loading]="vm.deleting"
              (clicked)="deleteOwner(vm.owner.id)"></sbnb-button>
            <sbnb-button
              class="block mt-8"
              label="Save"
              [disabled]="vm.loading"
              [loading]="vm.saving"
              (clicked)="save()"></sbnb-button>
          </div>
        </ng-container>

        <ng-template #loadingTemplate>
          <sbnb-loading-spinner></sbnb-loading-spinner>
        </ng-template>
      </div>
    </div>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Operations'">
  <sbnb-operations-subnav></sbnb-operations-subnav>
</sbnb-mobile-sidebar>
